<template>
    <div>
        <template v-if="!loading">
            <template v-if="alerts.length > 0">
                <div
                    v-for="alert in sorted_alerts"
                    :key="alert.id_alert"
                    class="alerts-configured-list__item d-flex align-center pa-3 mb-2"
                    :class="alert.triggered ? 'alerts-configured-list__item--triggered' : 'alerts-configured-list__item--untriggered'"
                    :style="getAlertStyles(alert)"
                >
                    <BadgeAlertWrapperComponent :alert="alert" v-on:refresh:alert="$emit('refresh:alert')" />
                    <template v-if="triggered">
                        <div class="ml-2">
                            <p class="font-color-medium font-weight-bold font-12 mb-n2 mt-1">
                                {{ $t('alerts_triggered_widget_component.alerts_triggered') }}
                            </p>
                            <p class="font-14 mb-0">{{ alert.label }}</p>
                        </div>
                    </template>
                    <template v-else>
                        <span class="ml-3 font-14">{{ alert.label }}</span>
                    </template>
                </div>
            </template>

            <template v-else>
                <v-alert v-if="triggered" dense text type="success">
                    {{ $t('alerts_triggered_widget_component.everything_work_fine') }}
                </v-alert>
                <p v-else class="mb-1 text-center">{{ $t('alerts_configured_component.no_alert_set') }}</p>
            </template>
        </template>

        <v-skeleton-loader v-for="n in 2" v-else :key="n" loading type="list-item-avatar" />
    </div>
</template>

<script>
import BadgeAlertWrapperComponent from '@/components/alert/containment/BadgeAlertWrapperComponent.vue'

export default {
    name: 'AlertsListComponent',
    components: { BadgeAlertWrapperComponent },
    props: {
        alerts: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        triggered: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        sorted_alerts() {
            return [...this.alerts].sort((a, b) => (b.triggered ? 1 : 0) - (a.triggered ? 1 : 0))
        },
    },
    methods: {
        getAlertStyles(alert) {
            const appearance = alert.configuration_appearance
            const hex = alert.acquitted
                ? '#9e9e9e'
                : alert.triggered
                ? appearance?.color_triggered
                : appearance?.color_untriggered

            let styles = {}

            if (hex) {
                const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})[a-f\d]{0,2}$/i.exec(hex)
                if (result) {
                    const [, r, g, b] = result
                    const rgb = `${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}`
                    styles = {
                        backgroundColor: `rgba(${rgb}, 0.08)`,
                        border: `1px solid rgba(${rgb}, 0.3)`,
                    }
                }
            }

            return styles
        },
    },
}
</script>

<style scoped>
.alerts-configured-list__item {
    border-radius: 12px;
}

.alerts-configured-list__item--triggered ::v-deep .v-btn {
    opacity: 0.75;
}
</style>
